import SoundVars from "../../src/const/SoundVars";
import SoundController from "../../src/utils/SoundController";
import GameModel from "../model/GameModel";
import RealityCheckModel from "../model/RealityCheckModel";
import FullscreenUtils from "../utils/FullscreenUtils";
import Layout from "../utils/Layout";
import { State } from "./State";
import App from "../../../core/src/App";
import PreloadView from "../../../core/src/views/PreloadView";
import GameLoader from "../../../core/src/utils/GameLoader";
import Locale from "../../../core/src/utils/Locale";
import gameModel from "../model/GameModel";
// TODO this should not be imported here
import GameEvents from "../const/GameEvents";
import ViewManager from "../../../core/src/utils/ViewManager";
import UIController from "../../src/ui/UIController";
import { DefaultLayers } from "../../src/utils/Layers";
import ReelGroup from "../../src/views/ReelGroup";
import InstanceFactory from "../factories/InstanceFactory";
import PointerEvents from "../const/PointerEvents";

import Reel from "../../src/views/Reel";
import SpinModel from "../model/SpinModel";
import { Loader } from "pixi.js";
import { UpdateUICommand } from "../commands/GameCommands";
import ErrorModel from "../model/ErrorModel";
import CommandManager from "../commands/CommandManager";
import { Commands } from "../commands/CommandEnum";
import { UIStates } from "../ui/UIStates";
import LocalData from "../utils/LocalData";
import LocalStorageVars from "../const/LocalStorageVars";
import BetModel from "../model/BetModel";
import VendorWrapper from "../../../src/controllers/VendorWrapper";
import ConsoleUtil from "../utils/ConsoleUtil";
import Utils from "../utils/Utils";


export default class PreloadState extends State {
  protected preloadView: PreloadView;
  public enter() {
    super.enter();
    BetModel.applyLastBet()

    GameLoader.loadLocalization(GameLoader.config.localizedContent, () => {
      // localization should be loaded first (could be used in preloader)
      GameLoader.loadAssets(GameLoader.config.configs || [], () => {
        GameLoader.loadAssets(
          GameLoader.config.initialResources,
          this.bootComplete.bind(this)
        );
    })});

    App.dispatcher.once(GameEvents.AUDIO_UNLOCKED, () => {
      // When audio is unlocked the user already clicked on the screen.
      // Due to android fullscreen api also requires user gesture,
      // This is a good time to request it.
      if (navigator.maxTouchPoints > 1 && GameModel.android && GameModel.urlParams.fullscreen != "false" && !Utils.inIframe()) {
        try {
          document.body.requestFullscreen();
        } catch (error) {
          ConsoleUtil.warn("requestFullscreen failed with the following error: " + error);
        }
      }
  });
  }

  public bootComplete(loader: Loader) {
    FullscreenUtils.init(VendorWrapper.onResize);
    Locale.addSource(loader.resources.localization.data);
    this.preloadView = InstanceFactory.getClass("PreloadView") as PreloadView;
    if (ViewManager.getDomLayer(DefaultLayers.Background)) {
      ViewManager.getDomLayer(DefaultLayers.Background).playDefault();
    }

    GameLoader.loadAssets(
      GameLoader.config.mainResources,
      // this.preloadComplete.bind(this),
      this.loadMusic.bind(this),
      this.preloadView.handleProgress.bind(this.preloadView)
    );
  }

  public preloadComplete() {
    App.assets.onResourcesLoaded();
    const preloadLayer = ViewManager.getLayer(DefaultLayers.Preloader);
    const scene = preloadLayer.setScene("start");
    scene.interactive = true;
    scene.on(PointerEvents.DOWN, () => {
      preloadLayer.clear();
      if (ErrorModel.hasError()) {
        this.exit();
      } else {
        this.buildViews();
        this.startGame();
      }
    });

    this.initSoundLoading();

    // TODO destroy preloader from view manager
  }

  protected setupReels() {
    const reelGroup = InstanceFactory.getClass("ReelGroup", true) as ReelGroup;
    ViewManager.getLayer(DefaultLayers.Reels)
      .getCurrentScene()
      .addSubView(reelGroup, "ReelGroup", "reels");
    reelGroup.create(
      ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene()
    );

  }

  protected buildViews() {
    App.dispatcher.emit(GameEvents.ASSETS_LOADED);
    GameModel.onBeforeReelGroupCreated(App);
    ViewManager.playDefault();
    this.setupReels();
    GameModel.onAfterReelGroupCreated(ReelGroup.instance);
  }

  // MUST run buildViews first
  protected startGame() {

    // Create the UI controller
    UIController.create();
    UIController.setState(UIStates.HIDDEN);
    // Update the bet bar
    CommandManager.execute(Commands.UPDATE_UI);

    // Update the info bar
    if(CommandManager.has(Commands.UPDATE_INFO_BAR)) {
      CommandManager.execute(Commands.UPDATE_INFO_BAR);
    }

    this.startMusicPlayback();
    App.dispatcher.emit(GameEvents.GAME_STARTED);
    this.exit();
  }

  protected initSoundLoading() {
    SoundController.musicVolume = App.config.maxMusicVolume || 1;
    GameLoader.loadSoundAssets(GameLoader.config.sounds, async () => {
      await SoundController.loadSounds(GameLoader.config.sounds);
      ConsoleUtil.log("Sound resources loaded");
      SoundController.playSound(SoundVars.EFFECT_REEL_STOP);
      SoundController.playMusic(SoundVars.MUSIC_MAIN);
      let storeMusicEnableValue = LocalData.getValue(LocalStorageVars.MUSIC_ENABLED);
      if(storeMusicEnableValue != null && storeMusicEnableValue != "true") {
        SoundController.stopMusic();
      }
    });
  }

  protected loadMusic() {
    if (GameLoader.config.music) {
      GameLoader.loadSoundAssets(GameLoader.config.music, async () => {
        await SoundController.loadSounds(GameLoader.config.music);
        this.preloadComplete();
      });
    } else {
      this.preloadComplete();
    }
  }

  protected startMusicPlayback() {  // DEPRECATED!!!
    // if (SoundController.soundsLoaded) {
    //   SoundController.playMusic(SoundVars.MUSIC_MAIN);
    // } else {
    //   SoundController.musicRequested = true;
    // }
  }
}
